export default __webpack_public_path__ + "i18n/translations/translation-ko.9a97ced8.json";